import {useEffect} from "react";

export const useCasesPolling = ({
  fn,
  deps,
  enabled,
  intervalsMs,
}) => {
  useEffect(() => {
    if (!enabled) return;
    const intervalId = setInterval(fn, intervalsMs);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, intervalsMs, fn, ...deps]);
}